import withTitle from "@material-dev/insights-portal-ui-components/lib/feature-components/m-title";
import existingBackground from "images/DM-Landing-Page-New-BG.svg";
import { homeStyles } from "./HomeStyles";
import OnBoardingDashboard from "./components/OnBoardingDashboard";

const PAGE_TITLE = "Data Manager - Home";
const Home = () => {
  const { classes } = homeStyles();  
  
  return (
    <div className={classes.homeContainer}>
      <div className={classes.home}>
        <img src={existingBackground} />  
      </div>
      <OnBoardingDashboard />
    </div>
  );
};

export default withTitle(Home, PAGE_TITLE);
